<app-badge badgeType="light" *ngIf="status == 'Rescheduled' || status == 'Checking dates'">
  {{ status }}
</app-badge>
<app-badge badgeType="danger" *ngIf="status == 'Cancelled' || status == 'Error'">
  {{ status }}
</app-badge>
<app-badge badgeType="info" *ngIf="status == 'Pending'">
  {{ status }}
</app-badge>
<app-badge badgeType="success" *ngIf="status == 'Scheduled'">
  {{ status }}
</app-badge>